import { getHouseId } from '@utils/house'
import PageFrom from './base'


class HouseSearchPageFrom extends PageFrom {
  constructor() {
    super('or-serp-house')
  }

  getTag(house, houseSearchType = null) {
    let hst = houseSearchType
    try {
      if (!houseSearchType) {
        // https://www.oneroof.co.nz/search/houses-for-sale/region_auckland-35_page_1
        hst = window.location.href.split('/search/')[1].split('/')[0]
      }
    } catch (error) {
    }
    return `SERP-${hst}-${getHouseId(house)}`
  }

  serpListingClick(house) {
    this.markePage(this.getTag(house))
  }

  isFrom(house, houseSearchType) {
    return this.getPageFrom() === this.getTag(house, houseSearchType)
  }
}

const houseSearchPageFrom = new HouseSearchPageFrom()
export default houseSearchPageFrom